import { odlocbaService } from '../services/odlocba.service';
import Vue from 'vue'

const state = {
    odlocba: [],
    sezona:null,
    pridelovalecid:null
};

const actions = {
    load({ dispatch,commit },{sezona,pridelovalecid,makeEditable}) {
        dispatch('alert/clear', "",{ root: true });
        commit('setSezona', sezona)
        commit('setPridelovalecID', pridelovalecid)
      return odlocbaService.load(sezona,pridelovalecid)
            .then(
                odlocba => {
                  commit('load', odlocba);
                  if(makeEditable)
                  commit('makeEditable') 
                  return odlocba;                   
                } 
                
            );
    },
    loadVse({ dispatch,commit },{sezona}) {
          dispatch('alert/clear', "",{ root: true });
        commit('load');
          commit('setSezona', sezona)
       return  odlocbaService.loadAll(sezona)
            .then(
                odlocba => commit('load', odlocba)
                //,
                //error => commit('getLoggedInFailure', error)
            );
    },
     
    save({ dispatch, commit }) {
     

         console.log("Shranjujem!");
        let sezona=this.state.odlocba.sezona;
        let pridelovalecid=this.state.odlocba.pridelovalecid;
        console.log(this.state);
        dispatch('alert/clear', "",{ root: true });

        this.state.odlocba.odlocba.forEach(item=>{
            item.sezona=sezona;
            item.pridelovalecid=pridelovalecid;
            console.log(item);
            if(!item.vrstaodlocbeid) {
                 item.saved=false;
                dispatch('alert/error', "Šifrant ni ustrezno izbran", { root: true });

            }
            else if(item.jeaktivna){
              odlocbaService.save(item)
               .then(
                odlocba => {
                     Vue.set(item,'saved',true);
                     Vue.set(item,'id',odlocba.id);
                     Vue.set(item,'jeaktivna',1);
                },
                error => {
                    console.log(error);
                       Vue.set(item,'saved',false);
                    
                    dispatch('alert/error', "Shranjevanje ni uspelo", { root: true });
                }
            );
            }
            else
             odlocbaService.remove(item).then(
                odlocba => {
                     Vue.set(item,'saved',true);
                    //commit("update",item);
                    
                },
                error => {
                    console.log(error);
                     Vue.set(item,'saved',false);
                  //  commit("update",item);
                    dispatch('alert/error', "Brisanje ni uspelo", { root: true });
                });
            //tukaj naredi ikono, da je shranjvanje uspešno na začetku ali nekje
            //uporabi info, če je prišlo kje do napake!

          });
       
        
    }
};

const mutations = {
  
    load(state, odlocba) {
                  if(odlocba)
        state.odlocba=odlocba.map(k=>{
            k["datumizdaje"]=kendo.parseDate(k["datumizdaje"]) 
            k["datumveljavnosti"]=kendo.parseDate(k["datumveljavnosti"]) 
          
            return k;
        }
            );  
    },
    add(state, item) {
        if(!item.id) {
            //do id
            var minid=state.odlocba.reduce((prev, curr) => prev.id < curr.id ? prev : curr,{id:0}).id;
            if(minid>0)
                minid=0;
            minid--;
            item.id=minid;
        }
        state.odlocba.push(item);
    },
    setSezona(state, item) {
        state.sezona=item;
    },
    makeEditable(state){
        for (var i=0;i<state.odlocba.length;i++){
            let dateStr=state.odlocba[i].veljavnostcertifikataod;
            if(dateStr)
                state.odlocba[i].veljavnostcertifikataod=new Date(dateStr);
            else
                state.odlocba[i].veljavnostcertifikataod=new Date( );
            let updated = Object.assign({}, state.odlocba[i], { inEdit: true });
            state.odlocba.splice(i,1,updated);
        }
        

    },
    setPridelovalecID(state, item) {
        state.pridelovalecid=item;
    },
  
    update(state, item) {
        //state.kultura = kultura;
        //state.kultura;
       
        let updated;
        let itemID = item.id
            let index = state.odlocba.findIndex(p =>
                (JSON.stringify({ ...p }) === JSON.stringify(item) )
                 || itemID && p.id === itemID);
            if (index >= 0) {
                updated = Object.assign({}, item);
                state.odlocba.splice(index,1,updated);
            } else {
                let id = 1;
                state.odlocba.forEach(p => { id = Math.max(p.id + 1, id); });
                updated = Object.assign({}, item, { id: id });
                state.odlocba.unshift(updated);
                index = 0;
            }



        //    return data[index];
        //state.kultura=data;

    },
    remove(state, item) {
        let itemID = item.id
            let index = state.odlocba.findIndex(p =>
                (JSON.stringify({ ...p }) === JSON.stringify(item) )
                 || itemID && p.id === itemID);
                console.log("Brisem!");
                console.log(index);
                console.log(state.odlocba);
                state.odlocba.splice(index, 1);
        
        //    return data[index];
        //state.odlocba=data;

    },
    replace(state, odlocba) {
        state.odlocba = odlocba;
    }
   
};

export const odlocba = {
    namespaced: true,
    state,
    actions,
    mutations
};
